import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class MultiSelectField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: []
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.onChange(value);
  }

  render() {
    const {
      value,
      name,
      options,
      placeholder,
      isDisabled = false
    } = this.props;
    const styles = {
      control: base => ({
        ...base,
        minHeight: '3rem',
        backgroundColor: '#fff',
        borderColor: 'black',
        borderRadius: 'none',
        boxShadow: 'rgba(0, 0, 0, 0.7) 0.4rem 0.4rem 0.08rem'
      }),
      multiValue: base => ({
        ...base,
        color: 'white',
        backgroundColor: '#009EB5',
        fontSize: '1.1rem'
      }),
      multiValueLabel: base => ({
        ...base,
        padding: '2px 5px',
        color: 'white',
        backgroundColor: '#009EB5',
        font: '300 1.1rem Poppins',
        fontStyle: 'italic'
      }),
      multiValueRemove: base => ({
        ...base,
        ':hover': {
          backgroundColor: 'rgba(0, 158, 181, .7)'
        }
      }),
      option: base => ({ ...base, font: '400 1.1rem Poppins' })
    };
    return (
      <Select
        isMulti
        name={name}
        value={value}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        isDisabled={isDisabled}
        className="form__form-group-select-multi"
        closeOnSelect={false}
        removeSelected={false}
        placeholder={placeholder}
        styles={styles}
      />
    );
  }
}

const renderMultiSelectField = ({
  input,
  options,
  style,
  isDisabled,
  placeholder,
  meta: { touched, error }
}) => (
  <div className="form__form-group-input-wrap">
    <MultiSelectField
      {...input}
      options={options}
      style={style}
      isDisabled={isDisabled}
      placeholder={placeholder}
    />
    {touched &&
      error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderMultiSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  options: PropTypes.array,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string
};

export default renderMultiSelectField;



// WEBPACK FOOTER //
// ./src/components/formFields/MultiSelect.js